import Request from '../../../../src/core/gd/data/request'

export type SessionMissingData = {

    projects?                   : ID[]      // depracated
    projectIds?                 : ID[]
    projectsWithParents?        : ID[]      // deprecated
    projectsWithParentsIds?     : ID[]
    taskTypes?                  : ID[]
    users?                      : ID[]
    customFields?               : ID[]
    statuses?                   : ID[]


    expenseCategoryReset?       : boolean
    // parser.add_argument('projectTypes', type=str, action='append')
    // parser.add_argument('missingProjectsTree', type=str, action='append')
    // parser.add_argument('projectsSettings', type=str, action='append')
    // parser.add_argument('users', type=inputEncodedId, action='append')
    // parser.add_argument('companyUsers', type=inputEncodedId, action='append')
    // parser.add_argument('noteTypes', type=inputEncodedId, action='append')
    // parser.add_argument('crmReset', type=boolean)
    // parser.add_argument('expenseCategoryReset', type=boolean)

}

export default class ApiSession {

    public publicKey: string = '' // exists in shared view api

    constructor() {

    }

    static fullResetV2(companyId: ID | null = null, requestResourceType: string | null = null, requestResourceId: ID | null = null, processSessionResponse: boolean = true) {
        return new Request(this,'GET','session/reset',{
            companyId, requestResourceType, requestResourceId
        },processSessionResponse, true);
    }

    static fullReset(companyId: ID | null = null, requestResourceType: string | null = null, requestResourceId: ID | null = null, processSessionResponse: boolean = true) {
        return new Request(this,'GET','session/reset',{
            companyId, requestResourceType, requestResourceId
        },processSessionResponse, true);
    }

    loadOlderCompanyAndPersonalEvents(companyId:ID, startMoment:Moment, endMoment:Moment) {
        return new Request(this, 'GET', 'session/events', {
            startDate: startMoment.format('YYYY-MM-DD'),
            endDate: endMoment.format('YYYY-MM-DD'),
        });
    }

    getForPrintToPdf(companyId:ID, userId:ID) {
        return new Request(this, 'GET', 'export-pdf/session', { companyId, userId });
    }

    resetMeetings() {
        return new Request(this, 'GET', 'session/reset-meetings');
    }

    resetReminders() {
        return new Request(this, 'GET', 'reminders/session-reset');
    }

    resetNoteTypes() {
        return new Request(this, 'GET', 'session/reset-notes');
    }

    resetTodoListTemplates() {
        return new Request(this, 'GET', 'session/todo-list-templates');
    }

    assignedPlanning() {
        return new Request(this, 'GET', 'session/assigned/planning');
    }

    // assignedResetAll() {
    //     return new Request(this, 'GET', 'session/assigned/reset');
    // }

    getMissingData(dataToLoad:SessionMissingData) {

        // New version - in future need to deal with it
        if (dataToLoad.projects) {
            dataToLoad.projectIds = dataToLoad.projects
            delete dataToLoad.projects
        }

        if (dataToLoad.projectsWithParents) {
            dataToLoad.projectsWithParentsIds = dataToLoad.projectsWithParents
            delete dataToLoad.projectsWithParents
        }

        return new Request(this, 'POST', 'session', dataToLoad);
    }

    resetMissing(params:any) {
        return new Request(this, 'POST', 'session/reset-missing', params);
    }
}
